import { render, staticRenderFns } from "./MLASubList.vue?vue&type=template&id=4855e2a4&scoped=true"
import script from "./MLASubList.vue?vue&type=script&lang=js"
export * from "./MLASubList.vue?vue&type=script&lang=js"
import style0 from "./MLASubList.vue?vue&type=style&index=0&id=4855e2a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4855e2a4",
  null
  
)

export default component.exports